import React, { useState, useEffect } from 'react'
// import './index.css'
import { Contract, CurrencyList, PurchaseDataReestr } from '../../types'
import { Structure } from '../../../Org/Structure/types'

import HoverTooltip from '../../../../../components/HoverTooltip'
import NumberFormat from '../../../components/DashboardCharts/NumberFormat'

type Props = {
    keyindex: number
    stage: string
    purchase: PurchaseDataReestr
    structData: Structure[]
    selected: boolean
    onClick: (purchase_reg_number: string) => void
    onDoubleClick: (purchase_reg_number: string) => void
    onRightClick: (purchase_reg_number: string) => void
    theme: string
    currency: CurrencyList[]
}

const CONTRACT_STATUS = new Map([
    ['F', 'Редактирование'],
    ['P', 'Размещено'],
    ['I', 'Недействительно'],
    ['M', 'Изменение'],
])

const CONTRACT_DRAFT_STATUS = new Map([
    ['P', 'Размещение'],
    ['A', 'Аннулирование позиции'],
    ['N', 'Новая позиция'],
    ['C', 'Изменение позиции'],
])

const MONTHS = [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь',
]

const GWS = new Map([
    ['G', 'Товар'],
    ['W', 'Работа'],
    ['S', 'Услуга'],
])

const PurchasesTableRow: React.FC<Props> = ({
    keyindex,
    stage,
    purchase,
    structData,
    selected,
    onClick,
    onDoubleClick,
    onRightClick,
    theme,
    currency,
}) => {
    const getNameStruct = (struct_guid: string) => {
        const nameSctruct = structData.find((s) => s.guid === struct_guid)
        return nameSctruct?.struct_short_name || '-'
    }

    const updatedDate = new Date(purchase.sys_updated_at)
    updatedDate.setHours(updatedDate.getHours())

    const formattedUpdateDate = updatedDate
        .toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
        .replace(/\//g, '.')
    const formattedUpdateTime = updatedDate.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    })

    const formatDateTime = (value: string | null | undefined) => {
        if (!value) {
            return {
                date: '',
                time: '',
            }
        }

        const date = new Date(value)

        return {
            date: date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }),
            time: date.toLocaleTimeString('ru-RU', {
                hour: '2-digit',
                minute: '2-digit',
            }),
        }
    }

    const createdDate = new Date(purchase.sys_created_at)
    createdDate.setHours(createdDate.getHours())

    const STATUS_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Черновик', '#9951FE'],
                  ['Готово', '#049664'],
                  //   ['Подготовка', '#745CFF'],
                  //   ['Готово к отправке', '#563AF5'],
                  ['Готово к отправке', '#9229EE'],
                  ['Отправлено', '#049664'],
                  ['Идет прием заявок', '#049664'],
                  ['Подача заявок', '#049664'],
                  ['Работа комиссии', '#6E0AC7'],
                  ['Закупка состоялась', '#63099F'],
                  ['Закупка не состоялась', '#515055'],
                  ['Закупка отменена', '#515055'],
                  ['Закупка завершена', '#515055'],
              ])
            : new Map([
                  ['Черновик', '#EADFFF'],
                  ['Готово', '#83D2B7'],
                  //   ['Подготовка', '#745CFF'],
                  //   ['Готово к отправке', '#563AF5'],
                  ['Готово к отправке', '#E3CFFF'],
                  ['Отправлено', '#83D2B7'],
                  ['Идет прием заявок', '#83D2B7'],
                  ['Подача заявок', '#83D2B7'],
                  ['Работа комиссии', '#DAAFFD'],
                  ['Закупка состоялась', '#C483F5'],
                  ['Закупка не состоялась', '#CFD6E2'],
                  ['Закупка отменена', '#CFD6E2'],
                  ['Закупка завершена', '#CFD6E2'],
              ])

    const STAGE_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Редактирование', '#9229EE'],
                  //   ['Подготовка к размещению', '#563AF5'],
                  ['Отправка', '#6E0AC7'],
                  ['Подача заявок', '#049664'],
                  ['Работа комиссии', '#63099F'],
                  ['Закупка завершена', '#42036C'],
                  ['Закупка отменена', '#515055'],
              ])
            : new Map([
                  ['Редактирование', '#E3CFFF'],
                  //   ['Подготовка к размещению', '#B7ACFF'],
                  ['Отправка', '#D49FFD'],
                  ['Подача заявок', '#83D2B7'],
                  ['Работа комиссии', '#C483F5'],
                  ['Закупка завершена', '#B759FF'],
                  ['Закупка отменена', '#CFD6E2'],
              ])

    const PURCHASE_STATUS_COLOR =
        theme == 'dark'
            ? new Map([
                  ['F', '#8E8E93'],
                  ['P', '#2A282B00'],
                  ['I', '#3A3A3C'],
                  ['M', '#636366'],
              ])
            : new Map([
                  ['F', '#E4E8F0'],
                  ['P', '#F6FBFF00'],
                  ['I', '#B7BECA'],
                  ['M', '#CFD6E2'],
              ])

    const addDaysAndFormatDate = (
        value: string | null | undefined,
        days: number
    ) => {
        if (!value) {
            return '-'
        }

        const date = new Date(value)
        date.setDate(date.getDate() + days)

        return date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
    }

    const submissionCloseDateTime = purchase.submission_close_date_time
        ? formatDateTime(purchase.submission_close_date_time)
        : null

    return (
        <div
            className={
                selected
                    ? 'plan-position-table-row-selected'
                    : 'plan-position-table-row'
            }
            onDoubleClick={() =>
                onDoubleClick(String(purchase.registration_number))
            }
            onClick={() => onClick(String(purchase.registration_number))}
            onContextMenu={(e) => {
                e.preventDefault() // Отключает стандартное контекстное меню
                onRightClick(String(purchase.registration_number))
            }}
        >
            <div className="flex h-[70px] w-8 items-center justify-center text-center">
                <input
                    type="checkbox"
                    checked={selected}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => {
                        onClick(String(purchase.registration_number))
                    }}
                />
            </div>
            <div className="flex h-[70px] w-12 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                {keyindex}
            </div>
            <div className="flex h-[70px] p-1 w-24 items-center justify-center text-center">
                <HoverTooltip
                    tooltipText={
                        purchase.registration_number
                            ? String(purchase.registration_number)
                            : '-'
                    }
                >
                    <p className="tworow">
                        {purchase.registration_number
                            ? purchase.registration_number
                            : '-'}
                    </p>
                </HoverTooltip>
            </div>
            <div
                className={`flex h-[70px] w-24 p-1 items-center justify-center text-center rounded`}
                style={{
                    backgroundColor: purchase.purchase_stage
                        ? STAGE_COLOR.get(purchase.purchase_stage)
                        : 'transparent',
                }}
            >
                {purchase.purchase_stage}
            </div>
            <div
                className="flex h-[70px] w-24 p-1 items-center justify-center text-center rounded"
                style={{
                    backgroundColor: purchase.purchase_status
                        ? STATUS_COLOR.get(purchase.purchase_status)
                        : 'transparent',
                }}
            >
                <HoverTooltip
                    tooltipText={
                        purchase.purchase_status
                            ? purchase.purchase_status
                            : '-'
                    }
                >
                    <p className="fourrow">{purchase.purchase_status}</p>
                </HoverTooltip>
            </div>

            <div className="flex h-[70px] flex-1 items-center justify-start text-left p-1 px-1">
                <HoverTooltip tooltipText={purchase.name ? purchase.name : '-'}>
                    <p className="fourrow">
                        {purchase.name ? purchase.name : '-'}
                    </p>
                </HoverTooltip>
            </div>

            {/* <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 gap-1">
                <HoverTooltip
                    tooltipText={
                        purchase.currency_digital_code
                            ? String(
                                  currency.find(
                                      (c) =>
                                          c.num_code ===
                                          String(purchase.currency_digital_code)
                                  )?.name
                              )
                            : '--'
                    }
                >
                    <span>
                        {purchase.currency_digital_code
                            ? purchase.currency_digital_code == 643
                                ? ''
                                : currency.find(
                                      (c) =>
                                          c.num_code ===
                                          String(purchase.currency_digital_code)
                                  )?.char_sign || '?'
                            : ''}{' '}
                        {Number(purchase.price).toLocaleString('ru-RU', {
                            minimumFractionDigits: 2,
                        })}
                    </span>
                </HoverTooltip>
            </div> */}

            <div className="flex h-[70px] w-28 items-center justify-end text-right px-2">
                {purchase.lots_sum ? (
                    <NumberFormat value={Number(purchase.lots_sum)} />
                ) : (
                    '-'
                )}
            </div>

            <div className="flex w-44 h-[70px] px-2 items-center justify-center text-center">
                <HoverTooltip
                    tooltipText={
                        purchase.purchase_method_name
                            ? purchase.purchase_method_name
                            : '-'
                    }
                >
                    <p className="fourrow">
                        {purchase.purchase_method_name
                            ? purchase.purchase_method_name
                            : '-'}
                    </p>
                </HoverTooltip>
            </div>

            {/* <div
                className="flex h-[70px] w-20 items-center justify-center text-center rounded"
                style={{
                    backgroundColor: purchase.status
                        ? PURCHASE_STATUS_COLOR.get(purchase.status)
                        : 'transparent',
                }}
            >
                {CONTRACT_STATUS.get(String(purchase.status))}
            </div> */}
            <div className="flex h-[70px] w-20 items-center justify-center text-center px-2 ">
                {purchase.lots_count}
            </div>

            <div className="flex h-[70px] w-24 items-center justify-center text-center px-2 ">
                {formatDateTime(purchase.publication_date_time).date}
            </div>

            <div className="flex h-[70px] w-24 items-center justify-center text-center px-2 ">
                {purchase.appl_submision_start_date
                    ? purchase.appl_submision_start_date
                          ?.split('-')
                          .reverse()
                          .join('-')
                          .replace(/[\-]/g, '.')
                    : '-'}
            </div>
            <div className="flex h-[70px] w-24 items-center justify-center text-center px-2 ">
                {submissionCloseDateTime ? (
                    <div className="flex flex-col items-center leading-5">
                        <span>&nbsp;</span>
                        <span>{submissionCloseDateTime.date}</span>
                        <span>{submissionCloseDateTime.time}</span>
                    </div>
                ) : (
                    '-'
                )}
            </div>

            <div className="flex h-[70px] w-24 items-center justify-center text-center px-2 ">
                {purchase.purchase_method_name
                    ? purchase.purchase_method_name
                          .toLowerCase()
                          .includes('единств')
                        ? formatDateTime(purchase.publication_date_time).date
                        : purchase.placing_procedure?.summingup_date_time
                          ? formatDateTime(
                                purchase.placing_procedure.summingup_date_time
                            ).date
                          : '-'
                    : '-'}
            </div>

            <div className="flex h-[70px] w-24 items-center justify-center text-center px-2 ">
                {addDaysAndFormatDate(
                    purchase.placing_procedure?.summingup_date_time,
                    20
                )}
            </div>

            <div className="flex h-[70px] w-20 items-center justify-center text-center">
                {purchase.version}
            </div>

            <div className="flex h-[70px] w-20 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                {formattedUpdateDate}
                <br />
                {formattedUpdateTime}
            </div>

            <div className="flex h-[70px] w-14 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                <HoverTooltip
                    tooltipText={
                        purchase.first_name !== null
                            ? purchase.last_name + ' ' + purchase.first_name
                            : 'Отсутствует'
                    }
                    align="left"
                >
                    <div className="flex h-8 w-8 rounded-full items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d9dce0] dark:bg-[#333033]">
                        {purchase.first_name !== null
                            ? purchase.last_name?.charAt(0) +
                              purchase.first_name?.charAt(0)
                            : 'О'}
                    </div>
                </HoverTooltip>
            </div>
        </div>
    )
}

export default PurchasesTableRow
